(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
// The CTA is a <button>, which has no href, so navigation is wired up here.
// Delegated from document so it survives section re-renders in the theme editor
// and covers every hero-banner instance on the page with one listener.
document.addEventListener('click', function (event) {
  var cta = event.target.closest('.hero-banner__cta[data-cta-url]');
  if (!cta) return;

  var url = cta.getAttribute('data-cta-url');
  if (url) window.location.href = url;
});

  } catch(e) { console.error(e); }
})();
})();
